import { render } from "./bundle-gallery-image-item.vue?vue&type=template&id=6f0eea30"
import script from "./bundle-gallery-image-item.vue?vue&type=script&lang=js"
export * from "./bundle-gallery-image-item.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__